import PropTypes from "prop-types";

const getInitials = (name) => {
  if (!name) return "?";

  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
};

const FeedbackCard = ({ quote, author, position, type }) => {
  return (
    <article
      className="
        flex h-full min-h-[330px] flex-col justify-between rounded-3xl
        border border-[#DDE7E5] bg-white p-6 shadow-sm
        transition-all duration-200 ease-out
        hover:-translate-y-1 hover:border-primary hover:shadow-xl
        dark:border-darkborder dark:bg-darksurface
        dark:hover:border-primary dark:hover:bg-darksurface2
      "
    >
      <div>
        <div className="mb-5 flex items-center justify-between gap-3">
          <span
            className="
              inline-flex rounded-full border border-primary/40 bg-primary/10
              px-3 py-1 font-customFont1 text-xs font-extrabold
              !text-[#111827]
              dark:!text-white
            "
          >
            {type}
          </span>

          <span
            aria-hidden="true"
            className="
              font-customFont2 text-5xl leading-none text-primary/40
              dark:text-primary/30
            "
          >
            ”
          </span>
        </div>

        <p
          className="
            font-customFont1 text-base font-normal leading-relaxed
            !text-[#374151]
            dark:!text-[#D1D5DB]
          "
        >
          “{quote}”
        </p>
      </div>

      <footer className="mt-8 flex items-center gap-4">
        <div
          className="
            flex h-14 w-14 shrink-0 items-center justify-center rounded-full
            border border-primary/40 bg-primary/15
            font-customFont1 text-sm font-extrabold !text-[#111827]
            dark:bg-primary/10 dark:!text-white
          "
          aria-hidden="true"
        >
          {getInitials(author)}
        </div>

        <div>
          <h3
            className="
              font-customFont1 text-base font-extrabold
              !text-[#111827]
              dark:!text-white
            "
          >
            {author}
          </h3>

          <p
            className="
              font-customFont1 text-sm font-semibold
              !text-[#6B7280]
              dark:!text-[#D1D5DB]
            "
          >
            {position}
          </p>
        </div>
      </footer>
    </article>
  );
};

FeedbackCard.propTypes = {
  quote: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default FeedbackCard;